export default {"src":"/_next/static/media/jumpstart.0ac6e70c.svg","height":512,"width":512};